import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {logExperiment} from '@homeaway/abacus-client-utils';
import ReactIntersectionObserver from '../../react-intersection-observer/ReactIntersectionObserver';

/**
 * Reports the exposure of a UI AB (aka multivariate) test
 */
class MvtTestComponent extends Component {
    static propTypes = {
        /** The name of the test whose exposure we want to report */
        test: PropTypes.string,
        /** Whether to report on mount (Full Exposure) or on visible (True Exposure) */
        reportOnMount: PropTypes.bool,
        /** The element whose exposure we want to track. See ReactIntersectionObserver children for details. */
        children: ReactIntersectionObserver.propTypes.children,
    };

    static defaultProps = {
        reportOnMount: false,
        children: null,
    };

    constructor(props) {
        super(props);
        this.state = {hasBeenSeen: false};
    }

    componentDidMount() {
        if (this.props.reportOnMount) {
            this.runLogExperiment();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const wasSeen = !prevState.hasBeenSeen && this.state.hasBeenSeen;
        if (wasSeen) {
            this.runLogExperiment();
        }
    }

    runLogExperiment() {
        const {abacus, test} = this.props;
        logExperiment(abacus[test]);
    }

    onIntersection = ({isIntersecting}) => {
        if (isIntersecting && !this.state.hasBeenSeen) {
            this.setState({hasBeenSeen: true});
        }
    };

    render() {
        return (
            <ReactIntersectionObserver
                rootMargin="0px 0px -10px 0px"
                onIntersection={this.onIntersection}
            >
                {this.props.children}
            </ReactIntersectionObserver>
        );
    }
}

const mapStateToProps = ({abacus}) => ({abacus});

export const MvtTest = connect(mapStateToProps)(MvtTestComponent);

MvtTest.displayName = 'MvtTest';

export default MvtTest;
